import CreateIcon from '@mui/icons-material/Create';
import { Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { getBusinessContacts } from 'lib/api/contacts';
import CreateContact from 'lib/common/Forms/Contacts/Create';
import ContactsTable from 'lib/common/Tables/ContactsTable';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import { validatePermissions } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import ContactNetwork from './Components/ContactNetwork';

type Props = {
  businessId?: string | null;
};

const ContactsComponent: React.FC<Props> = ({ businessId }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { id } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const businessIdentifier = businessId || id;
  const { data, isPending } = getBusinessContacts(dispatch, businessIdentifier);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [networkDialogOpen, setNetworkDialogOpen] = useState(false);

  const contacts = data?.items ?? [];

  const canEdit = () => validatePermissions(user, 'businesses_create_new');

  const buttons: CustomButtonProps[] = [
    {
      name: 'Buscar contacto en red',
      action: () => setNetworkDialogOpen(true),
      color: 'secondary',
      disabled: !canEdit(),
    },
    {
      name: 'Crear',
      action: () => setCreateDialogOpen(true),
      color: 'primary',
      disabled: !canEdit(),
    },
  ];

  if (isPending) return <CenteredCircularProgress relative />;

  return (
    <Stack spacing={2}>
      <HeaderWithActions
        variant="body1"
        subHeader
        buttons={buttons}
        title="Acá podrás ver y editar los contactos de la empresa."
      />
      <ContactsTable data={contacts} showBusiness={false} />
      <Dialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
      >
        <DialogTitle
          onClose={() => setCreateDialogOpen(false)}
          title="Crear contacto"
          icon={<CreateIcon color="primary" />}
          color="primary"
        />
        <DialogContent>
          <CreateContact
            businessIdentifier={businessIdentifier}
            onCreated={() => setCreateDialogOpen(false)}
          />
        </DialogContent>
      </Dialog>

      <ContactNetwork
        open={networkDialogOpen}
        setOpen={setNetworkDialogOpen}
        identifier={businessIdentifier}
      />
    </Stack>
  );
};

export default ContactsComponent;
